import { render } from "./SocialIcon.vue?vue&type=template&id=78ee74c3"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"

import "./SocialIcon.vue?vue&type=style&index=0&id=78ee74c3&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__